import React, { memo, useCallback, useMemo } from "react";
import { Box, Container, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { stepsPaths } from "../../constants";
import { StepPathType } from "../../shared";
import { Header } from "../Header";
import { MainMenu } from "../MainMenu";
import { LeftArrowThin, RightArrowThin } from "../shared/icons";
import { StepSwitchButton } from "./StepSwitchButton";
import ButtonsScene from "../SceneObjects/ButtonsScene/ButtonsScene";
import VersionInfo from "../SceneObjects/VersionInfo/VersionInfo";
import ConfLoader from "../SceneObjects/Loader/ConfLoader";
import { useLoading } from "../../hooks/useLoading";
import Loader from "../SceneObjects/Loader/Loader";
import { useCurrentSearchParam } from "../../utils/hooks/useCurrentSearchParam";
import { LoadProjectModal } from "../Modals/LoadProjectModal/LoadProjectModal";
import { useStoreSystem } from "../../store";
import { useProgress } from "@react-three/drei";
import shallow from "zustand/shallow";
import { ViewFullscreenHint } from "../ViewFullscreen/ViewFullscreenHint";
import { VIEW_FULLSCREEN_ROOT_ID } from "../../hooks/useViewFullscreen";
import styles from "./Layout.module.scss";

type OwnProps = {
    children: React.ReactElement;
};
export const Layout = memo(({ children }: OwnProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const current = location.pathname.split("/")[1];
    const stepIndex = useMemo(() => stepsPaths.indexOf(current as StepPathType), [current]);
    const { isLoading } = useLoading()
    const [, , hashForUrl] = useCurrentSearchParam('hash')
    const { projectModalIsOpen, proMode } = useStoreSystem(state => ({
        projectModalIsOpen: state.projectModal.isOpen,
        proMode: state.proMode,
    }), shallow);

    const { loaded } = useProgress();

    const onLeftStepSwitchButton = useCallback(() => {
        stepIndex !== -1 ? navigate(stepsPaths[stepIndex - 1] + hashForUrl) : navigate(stepsPaths[0] + hashForUrl);
    }, [stepIndex, navigate]);
    const onRightStepSwitchButton = useCallback(() => {
        stepIndex !== -1 ? navigate(stepsPaths[stepIndex + 1] + hashForUrl) : navigate(stepsPaths[0] + hashForUrl);
    }, [stepIndex, navigate, location]);
    return (
        <>
            {isLoading &&
                <Loader isLoading={isLoading} />
            }
            <ConfLoader />
            <Container disableGutters maxWidth={false} sx={{ height: "100vh", overflow: 'hidden' }}>
                <Stack height={"100%"} justifyContent={"stretch"}>
                    <Header />
                    <Box
                        id={VIEW_FULLSCREEN_ROOT_ID}
                        component={"div"}
                        flexGrow={1}
                        position="relative"
                        className={styles.viewFullscreenRoot}
                    >
                        {children}
                        <ViewFullscreenHint />

                        {/* {stepIndex !== 0 && stepIndex !== -1 && (    //TODO пока стрелки отключили, на макете их нет
                            <StepSwitchButton onClick={onLeftStepSwitchButton}>
                                <LeftArrowThin />
                            </StepSwitchButton>
                        )} */}

                        {/* {current !== "specification" && stepIndex !== -1 && (
                            <StepSwitchButton right onClick={onRightStepSwitchButton}>
                                <RightArrowThin />
                            </StepSwitchButton>
                        )} */}
                    </Box>
                    <ButtonsScene proMode={proMode} />
                    <MainMenu proMode={proMode} />

                </Stack>
                {loaded && projectModalIsOpen &&
                    <LoadProjectModal />
                }
            </Container>


        </>
    );
})
